// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

jQuery(function () {



 
  var testimonialSwiper = new Swiper(".testimonialSwiper", {
     modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 3,        
    spaceBetween: 30,        
    loop: true,
      // Navigation arrows
    navigation: {
      nextEl: '.testimonialSwiper-next',
      prevEl: '.testimonialSwiper-prev',
    },

    // Ajout de la configuration responsive pour s'adapter aux différents écrans
    breakpoints: {
      // Quand la largeur d'écran est < 576px
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      1100: {
        slidesPerView: 2,
        spaceBetween: 20
      },
    }
  }); 


  // Initialisation du slider des partenaires
  var partnersSwiper = new Swiper(".partnersSwiper", {
    slidesPerView: 3,       
    spaceBetween: 30,       
    loop: true,
    modules: [Navigation],

    navigation: {
      nextEl: ".partners-next", 
      prevEl: ".partners-prev",
    }, 
    // Configuration responsive
    breakpoints: {
      // Mobile
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // Tablette
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      // Desktop
      992: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  });

});
